import { useTranslation } from 'react-i18next';
import { useCart } from '@/context/CartContext';

export default function OpeningHours() {
  const { t } = useTranslation();
  const { openCart } = useCart();
  const days = t('hours.days', { returnObjects: true }) as unknown as string[];

  return (
    <section id="hours" className="relative w-full overflow-hidden py-16 md:py-24">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20moody%20restaurant%20background%20with%20soft%20bokeh%20of%20amber%20candlelight%20and%20hanging%20warm%20bulbs%2C%20empty%20elegant%20dining%20tables%20at%20night%2C%20rich%20charcoal%20and%20gold%20tones%2C%20cozy%20cinematic%20atmosphere&width=1800&height=1000&seq=hours-bg-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/75"></div>
      </div>

      <div className="relative z-10 mx-auto grid max-w-7xl gap-12 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.3em] uppercase text-accent-400">
            <span className="h-px w-8 bg-accent-500"></span>
            {t('hours.eyebrow')}
          </span>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight text-background-50 md:text-4xl">
            {t('hours.title')}
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-background-100/90">
            {t('hours.subtitle')}
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
            <button
              type="button"
              onClick={openCart}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 px-6 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
            >
              <i className="ri-smartphone-line"></i>
              {t('hours.order')}
            </button>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/40 px-6 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10"
            >
              <i className="ri-map-pin-2-line"></i>
              {t('hours.map')}
            </a>
          </div>
        </div>

        <div className="rounded-lg border border-background-50/15 bg-background-950/40 p-6 backdrop-blur md:p-8">
          <div className="flex items-center justify-between border-b border-background-50/15 pb-4">
            <span className="font-heading text-lg font-semibold text-background-50">{t('hours.schedule')}</span>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <span className="h-1.5 w-1.5 rounded-full bg-secondary-500"></span>
              {t('hours.open')}
            </span>
          </div>
          <ul className="mt-4 flex flex-col">
            {(days || []).map((day) => (
              <li
                key={day}
                className="flex items-center justify-between border-b border-background-50/10 py-3"
              >
                <span className="text-sm text-background-100">{day}</span>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-400">
                  <i className="ri-time-line"></i>
                  {t('hours.open24')}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-5 flex items-center gap-2 text-sm text-background-100/80">
            <i className="ri-map-pin-2-line text-accent-400"></i>
            {t('info.address')}
          </p>
        </div>
      </div>
    </section>
  );
}